var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#454f63;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M18.782,12.318a7.308,7.308,0,0,1-6.464,6.464v.9a.818.818,0,1,1-1.636,0v-.9a7.159,7.159,0,0,1-6.464-6.464h-.9a.818.818,0,1,1,0-1.636h.9a7.159,7.159,0,0,1,6.464-6.464v-.9a.818.818,0,1,1,1.636,0v.9a7.308,7.308,0,0,1,6.464,6.464h.9a.818.818,0,1,1,0,1.636ZM11.5,17.227A5.727,5.727,0,1,0,5.773,11.5,5.692,5.692,0,0,0,11.5,17.227Zm0-2.455A3.273,3.273,0,1,1,14.773,11.5,3.282,3.282,0,0,1,11.5,14.773Zm0-1.636A1.636,1.636,0,1,0,9.864,11.5,1.641,1.641,0,0,0,11.5,13.136Z",
    transform: "translate(0.5 0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGps);
export default __webpack_public_path__ + "static/media/gps.08f30f3404867afad67dbc6f0b6dc5cc.svg";
export { ForwardRef as ReactComponent };